import React, { useEffect, useState } from 'react';
import {
  Box, Grid, Stack, Typography
} from '@mui/material';
import { ClassNameMap, withStyles } from '@mui/styles';
import stylesheet from '../detail-container.stylesheet';
import moment from 'moment';


interface IProps {
  input: any,
  classes: ClassNameMap
}

const TaskDelayComponent: React.FC<IProps> = ({ input, classes }) => {
  const [taskAtmtsData, setTaskAtmtpsData] = useState({}) as any
  const [delayTrailData, setDelayTrailData] = useState({}) as any

  useEffect(() => {
    if (input) {
      setTaskAtmtpsData(input?.attempts || {})
      setDelayTrailData(input?.delays || {})
    }
  }, [input])

  const renderLogVal = (title: any, val: any) => {
    return <Grid container direction="row" className={classes.evalToxCard}>
      <Grid item><Typography className={classes.evalBoxVal}>{title}</Typography></Grid>
      <Grid item><Typography className={classes.toxicityEvalBoxVal}>{val}</Typography></Grid>
    </Grid>
  }

  const renderLogNotes = (notesData: any) => {
    return (notesData?.sort((a: any, b: any) => a.date < b.date ? 1 : -1) || [])?.map((r: any) =>
      <Box pb={0.6}>
        <Typography className={classes.toxicityEvalBoxVal}>{r?.note}</Typography>
        <Typography pl={0.6}
          sx={{ fontSize: '0.62rem !important', color: 'grey !important' }}>
          {(r?.date !== undefined)
            ? `attempted by ${r.attempted_by} on ${moment.unix(r?.date).format('MMM DD, YYYY hh:mm a')}`
            : <>-</>
          }
        </Typography>
      </Box>
    )
  }

  return (
    <Stack className={classes.taskNotesBox} direction={'column'} spacing={1}
      sx={{ minHeight: '4rem', padding: '0.5rem 0.5rem 0rem 0rem', width: 'inherit' }}
    >
      {taskAtmtsData.count > 0 &&
        <Stack direction={'column'}>
          {renderLogVal('Days since last attempt', taskAtmtsData.days_since_last_attempt)}
          {taskAtmtsData.last_attempt_date &&
            renderLogVal('Last attempt date', moment.unix(taskAtmtsData.last_attempt_date).format('MMM DD, YYYY hh:mm a'))
          }
          {taskAtmtsData.next_allowed_attempt_date &&
            renderLogVal('Next allowed attempt date', moment.unix(taskAtmtsData.next_allowed_attempt_date).format('MMM DD, YYYY hh:mm a'))
          }
          <Box pt={0.5}>
            {renderLogNotes(taskAtmtsData?.data)}
          </Box>
        </Stack>
      }
      {delayTrailData.count > 0 &&
        <Stack direction={'column'}>
          {renderLogVal('Days since last delay', delayTrailData.days_since_last_delay)}
          {delayTrailData.first_delayed_on &&
            renderLogVal('First delayed on',
              moment.unix(delayTrailData.first_delayed_on).format('MMM DD, YYYY hh:mm a')
            )
          }
          {delayTrailData.last_delayed_on &&
            renderLogVal('Last delayed on', moment.unix(delayTrailData.last_delayed_on).format('MMM DD, YYYY hh:mm a'))
          }
          <Box pt={0.5}>
            {delayTrailData?.delay_trail?.map((i: any) =>
              <Box pb={0.6}>
                <Typography className={classes.toxicityEvalBoxVal}>
                  {i?.justification}
                </Typography>
                <Typography pl={0.6}
                  sx={{ fontSize: '0.62rem !important', color: 'grey !important' }}>
                  {(i?.delay_date !== undefined)
                    ? `delayed by ${i?.author?.name || ''} on 
                            ${moment.unix(i?.delay_date).format('MMM DD, YYYY hh:mm a')}`
                    : <>-</>
                  }
                </Typography>
              </Box>
            )}
          </Box>
        </Stack>
      }
    </Stack>
  )
}

export default withStyles(stylesheet)(TaskDelayComponent);